export function distinct<T>(array: T[], predicate: (item: T) => unknown = v => v): T[] {
    const set = new Set();
    const result = [];

    for (const item of array) {
        const value = predicate(item);

        if (!set.has(value)) {
            set.add(value);
            result.push(item);
        }
    }

    return result;
}
